/*
 *
 * CabinetRibbon constants
 *
 */

enum ActionTypes {
  DEFAULT_ACTION = 'app/FurnitureRibbon/DEFAULT_ACTION',
}

export const marksWidth = [
  {
    value: 250,
  },
  {
    value: 320,
  },
  {
    value: 420,
  },
  {
    value: 520,
  },
  {
    value: 620,
  },
  {
    value: 800,
  },
  {
    value: 900,
  },
  {
    value: 1000,
  },
  {
    value: 1100,
  },
  {
    value: 1200,
  },
];

export const marksDepth = [
  {
    value: 250,
  },
  {
    value: 320,
  },
  {
    value: 420,
  },
  {
    value: 520,
  },
  {
    value: 620,
  },
];

export default ActionTypes;
